import React from "react";
import { useSelector } from "react-redux";
import Spinner from "react-bootstrap/Spinner";

export default function GlobalLoader() {
  const { loading } = useSelector((state) => state.USER_DATA);

  if (!loading) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(255,255,255,0.7)",
        zIndex: 9999,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Spinner animation="border" variant="primary" size="lg" />
    </div>
  );
}
